import React, { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Pagination from "../Reusablecomponents/Pagination";
import ExportButton from "../Reusablecomponents/ExportButton";
import "../css/others/Table.css";
import "../css/others/Popup.css";
import { apiCall } from "../main/ApiCall";
import { ExcludedCampaignProjectRow, IStatusEnum } from "../interFaces/interfaces";
const ExcludedCampaignAndProject: React.FC = () => {
    const { campaignId } = useParams<{ campaignId: string }>();
    const navigate = useNavigate();
    const [data, setData] = useState<ExcludedCampaignProjectRow[]>([]);
    const [, setLoading] = useState<boolean>(true);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [itemsPerPage, setItemsPerPage] = useState<number>(10);
    const [totalPages, setTotalPages] = useState<number>(0);
    const [totalElements, setTotalElements] = useState<number>(0);
    const [statusEnums, setStatusEnums] = useState<IStatusEnum[]>([]);
    const columns = [{ key: "projectId", label: "Project ID" }, { key: "lastProjectsExcludedDate", label: "Last Excluded Date" }, { key: "lastExcludedBy", label: "Last Excluded By" }, { key: "currentStatus", label: "Current Status" }];
    const formatDate = (dateString: string | undefined | null): string => {
        if (!dateString) return "";
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return dateString;
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };
    const fetchExcludedRefs = useCallback(async () => {
        if (!campaignId) return;
        setLoading(true);
        try {
            const response = await apiCall("get", `/api/campaigns/excluded-refs/${campaignId}?page=${currentPage - 1}&size=${itemsPerPage}`);
            setData(response?.content || []);
            setTotalPages(response?.totalPages || 0);
            setTotalElements(response?.totalElements || 0);
        } catch (error) {
            console.error("Error fetching excluded refs:", error);
        } finally {
            setLoading(false);
        }
    }, [campaignId, currentPage, itemsPerPage]);
    useEffect(() => {
        fetchExcludedRefs();
    }, [fetchExcludedRefs]);
    const fetchAllExcludedRefs = async (): Promise<ExcludedCampaignProjectRow[]> => {
        if (!campaignId) return [];
        try {
            const response = await apiCall("get", `/api/campaigns/excluded-refs/${campaignId}?page=0&size=${totalElements || 9999}`);
            if (!response?.content) return [];
            const transformedData = response.content.map((item: ExcludedCampaignProjectRow) => ({ ...item, currentStatus: item.currentStatus ? getStatusDescription(item.currentStatus) : "N/A", lastProjectsExcludedDate: formatDate(item.lastProjectsExcludedDate) }));
            return transformedData;
        } catch (error) {
            console.error("Failed to export excluded refs:", error);
            return [];
        }
    };
    useEffect(() => {
        const fetchStatusEnums = async () => {
            try {
                const response = await apiCall("get", "/api/enums/ItemStatusEnum");
                setStatusEnums(response);
            } catch (error) {
                console.error("Error fetching status enums:", error);
            }
        };
        fetchStatusEnums();
    }, []);
    const getStatusDescription = (statusValue: string) => {
        const foundStatus = statusEnums.find(enumItem => enumItem.value === statusValue);
        return foundStatus ? foundStatus.description : statusValue;
    };
    const handleProjectClick = (projectId: string) => {
        if (!campaignId) return;
        navigate(`/excludedcampaignprojectdetails/${campaignId}/${projectId}`);
    };
    const renderProjectId = (row: ExcludedCampaignProjectRow) => (
        <span className="clickable" onClick={() => handleProjectClick(row.projectId)}>{row.projectId || "N/A"}</span>
    );
    return (
        <div className="table-details">
            <div className="table-title">
                <h2>Excluded Campaign Project</h2>
                <div className="table-title-actions">
                    <ExportButton data={data} columns={columns} fetchAllData={fetchAllExcludedRefs} fileName={`excluded_refs_${campaignId || "campaign"}`} />
                </div>
            </div>
            <div className="table-container">
                <div className="table-inner-container">
                    <table className="main-table">
                        <thead>
                            <tr>
                                {columns.map((column) => (
                                    <th key={column.key}>{column.label}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {data.length > 0 ? (
                                data.map((row, idx) => (
                                    <tr key={`${row.projectId}-${idx}`}>
                                        <td>{renderProjectId(row)}</td>
                                        <td>{formatDate(row.lastProjectsExcludedDate)}</td>
                                        <td>{row.lastExcludedBy || "N/A"}</td>
                                        <td>{row.currentStatus ? getStatusDescription(row.currentStatus) : "N/A"}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={columns.length} className="no-data">No excluded projects found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            <Pagination currentPage={currentPage} totalPages={totalPages} totalElements={totalElements} itemsPerPage={itemsPerPage} onPageChange={setCurrentPage} onItemsPerPageChange={setItemsPerPage} />
        </div>
    );
};
export default ExcludedCampaignAndProject;